var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgErrorBig = function SvgErrorBig(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24,
    cy: 24,
    fill: "#fff",
    rx: 6,
    ry: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.214 44.319h33.572c3.205 0 5.214-2.307 5.214-5.213 0-.876-.214-1.751-.684-2.563L28.498 6.528a5.144 5.144 0 0 0-8.997 0L2.706 36.564C2.256 37.376 2 38.23 2 39.106c0 2.906 2.009 5.213 5.214 5.213m16.797-14.27c-1.111 0-1.71-.641-1.731-1.774l-.3-11.621c-.02-1.132.813-1.944 2.01-1.944 1.175 0 2.05.833 2.03 1.965l-.3 11.6c-.021 1.154-.64 1.774-1.71 1.774m0 7.156c-1.261 0-2.372-1.025-2.372-2.286 0-1.282 1.09-2.307 2.372-2.307 1.303 0 2.393 1.004 2.393 2.307 0 1.282-1.111 2.286-2.393 2.286"
  })));
};
export default SvgErrorBig;